export const datatableTheme = {
  colorScheme: {
    light: {
      root: {
        transitionDuration: '{transition.duration}'
      },
      header: {
        background: 'transparent',
        borderColor: 'var(--surface-stroke)',
        color: '{content.color}',
        borderWidth: '0',
        padding: '0px',
        sm: { padding: '0px' },
        xsmall: { padding: '0px' }
      },
      headerCell: {
        background: 'transparent',
        borderColor: 'var(--surface-stroke)',
        color: 'var(--text-primary)',
        selectedColor: 'var(--text-primary)',
        selectedBackground: 'var(--surface-fill)',
        sm: { padding: '0.375rem 1rem' },
        lg: { padding: '1rem 1.25rem' },
        xsmall: { padding: '0.30rem 0.375rem' }
      },
      row: {
        background: 'transparent'
      },
      bodyCell: {
        background: 'transparent',
        borderColor: 'var(--surface-stroke)',
        sm: { padding: '0.375rem 1rem' },
        lg: { padding: '1rem 1.25rem' },
        xsmall: { padding: '0.30rem 0.375rem' }
      },
      footerCell: {
        background: 'transparent',
        borderColor: 'transparent',
        color: 'var(--text-primary)',
        xsmall: { padding: '0.30rem 0.375rem' }
      },
      footer: {
        background: 'transparent',
        borderColor: 'transparent',
        color: 'var(--text-primary)'
      },
      dropPointColor: '{primary.color}',
      resizeIndicator: {
        color: '{primary.color}'
      },
      loadingIcon: {
        size: '430px'
      },
      rowToggleButton: {
        color: 'var(--text-primary)'
      },
      filter: {
        overlaySelect: {
          background: 'transparent',
          borderColor: 'var(--surface-stroke-divider-formfield)',
          color: 'var(--text-primary)'
        },
        overlayPopover: {
          background: 'transparent',
          borderColor: 'var(--surface-stroke-divider-formfield)',
          color: 'var(--text-primary)'
        },
        rule: {
          borderColor: 'var(--surface-stroke)'
        },
        constraint: {
          focusBackground: 'var(--text-bg-hover-2)',
          selectedBackground: 'var(--text-bg-selected)',
          color: 'var(--text-primary)',
          separator: {
            borderColor: 'var(--surface-stroke-divider)'
          }
        }
      },
      paginatorTop: {
        borderColor: 'var(--bs-border-color)',
        borderWidth: '1px'
      },
      paginatorBottom: {
        borderColor: 'var(--bs-border-color)',
        borderWidth: '1px'
      }
    },
    dark: {
      root: {
        transitionDuration: '{transition.duration}'
      },
      header: {
        background: 'transparent',
        borderColor: '{gray.700}',
        color: '{content.color}',
        borderWidth: '0',
        padding: '0px',
        sm: { padding: '0px' },
        xsmall: { padding: '0px' }
      },
      headerCell: {
        background: 'transparent',
        borderColor: '{gray.700}',
        color: 'var(--text-primary)',
        selectedColor: 'var(--text-primary)',
        selectedBackground: 'var(--surface-fill)',
        sm: { padding: '0.375rem 1rem' },
        lg: { padding: '1rem 1.25rem' },
        xsmall: { padding: '0.30rem 0.375rem' }
      },
      row: {
        background: 'transparent'
      },
      bodyCell: {
        background: 'transparent',
        borderColor: '{gray.700}',
        sm: { padding: '0.375rem 1rem' },
        lg: { padding: '1rem 1.25rem' },
        xsmall: { padding: '0.30rem 0.375rem' }
      },
      footerCell: {
        background: 'transparent',
        borderColor: 'transparent',
        color: 'var(--text-primary)',
        xsmall: { padding: '0.30rem 0.375rem' }
      },
      footer: {
        background: 'transparent',
        borderColor: 'transparent',
        color: 'var(--text-primary)'
      },
      dropPointColor: '{primary.color}',
      resizeIndicator: {
        color: '{primary.color}'
      },
      loadingIcon: {
        size: '430px'
      },
      rowToggleButton: {
        color: 'var(--text-primary)'
      },
      filter: {
        overlaySelect: {
          background: 'transparent',
          borderColor: 'var(--surface-stroke-divider-formfield)',
          color: 'var(--text-primary)'
        },
        overlayPopover: {
          background: 'transparent',
          borderColor: 'var(--surface-stroke-divider-formfield)',
          color: 'var(--text-primary)'
        },
        rule: {
          borderColor: '{gray.700}'
        },
        constraint: {
          focusBackground: 'var(--text-bg-hover-2)',
          selectedBackground: 'var(--text-bg-selected)',
          color: 'var(--text-primary)',
          separator: {
            borderColor: 'var(--surface-stroke-divider)'
          }
        }
      },
      paginatorTop: {
        borderColor: 'var(--bs-border-color)',
        borderWidth: '1px'
      },
      paginatorBottom: {
        borderColor: 'var(--bs-border-color)',
        borderWidth: '1px'
      }
    }
  },
  css: ({ dt }: { dt: any }) => `
    /* Mogenius Table Base Styles */
    .p-datatable-thead {
      height: 54px;
    }

    .p-datatable-tbody > tr:last-child > td {
      border-bottom: none;
    }

    p-sorticon {
      margin-left: 4px;
    }

    .p-datatable.p-datatable-sm .p-datatable-tbody > tr > td {
      height: 46px;
    }

    /* XSmall Size Support */
    .p-datatable .p-datatable-xsmall .p-datatable-thead > tr > th {
      padding: ${dt('datatable.headerCell.xsmall.padding')};
      font-size: 0.75rem;
      line-height: 1.2;
    }

    .p-datatable .p-datatable-xsmall .p-datatable-tbody > tr > td {
      padding: ${dt('datatable.bodyCell.xsmall.padding')};
      font-size: 0.75rem;
      line-height: 1.2;
    }

    .p-datatable .p-datatable-xsmall .p-datatable-tfoot > tr > td {
      padding: ${dt('datatable.footerCell.xsmall.padding')};
      font-size: 0.75rem;
    }

    /* Optional: Paginator auch kleiner machen */
    .p-datatable .p-datatable-xsmall .p-paginator {
      font-size: 0.75rem;
    }

    .p-datatable .p-datatable-xsmall .p-paginator .p-paginator-element {
      min-width: 1.75rem;
      height: 1.75rem;
    }
  `
};
